import React from 'react';

function EPSupport() {
  return (
    <div>EPSupport</div>
  );
}

export default EPSupport;
